export const generateRandomId = () => Math.random().toString(36).substring(2, 9);
export const deepCloneObject = (obj) => JSON.parse(JSON.stringify(obj));
